import router from "@/router/router"
import axios, { type AxiosError } from "axios"
import { EMAIL_TOKEN_NAME, useAuthService } from '@/utils/auth.ts'
import { showErrorToastGlobal } from "@/utils/toast"

type ApiFieldError = { field?: string; message: string }

const $axios = axios.create({
  baseURL: import.meta.env.VITE_MENU_URL
})

$axios.interceptors.request.use(config => {
  // const accessToken = document.cookie
  //   .split('; ')
  //   .find(row => row.startsWith(import.meta.env.MODE === 'production' ? 'token=' : 'devToken='))
  //   ?.split('=')[1]
  const accessToken = localStorage.getItem(EMAIL_TOKEN_NAME)
  if (accessToken) {
    config.headers['X-Access-Token'] = `Bearer ${accessToken}`
  }
  return config
})

$axios.interceptors.response.use(response => response, async (error: AxiosError) => {
    const status = error.response?.status
    if (status === 401 || status === 403) {
        const authService = useAuthService()
        authService.removeRahmatToken()
        // window.location.href = "/login"
        setTimeout(() => {
            showErrorToastGlobal('Требуется авторизация', 'Войдите в аккаунт повторно')
        }, 200)
        await router.push({ name: 'login' })
    } else {
      const detail = extractApiErrorDetail(error.response?.data)
      if (detail) {
        showErrorToastGlobal('Ошибка', detail)
      }
    }
    return Promise.reject(error)
  }
)

const extractApiErrorDetail = (data: unknown): string | null => {
    if (!data || typeof data !== 'object') return null
    const body = data as Record<string, unknown>
    if (body.success !== false) return null

    const err = body.error
    if (!Array.isArray(err)) return null

    const parts: string[] = []
    for (const item of err) {
        if (!item || typeof item !== 'object') continue
        const row = item as ApiFieldError
        if (typeof row.message !== 'string' || !row.message) continue
        parts.push(row.field ? `${row.field}: ${row.message}` : row.message)
    }
    return parts.length ? parts.join('\n') : null
}

export default $axios
